import { Component, OnInit } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../shared/service/app/app.service';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from './../../../shared/service/common/common.service';
import { UserDTO, UserSendCodeDTO } from './../../../shared/dto/user.dto';
import { AlertService } from '../../../shared/service/common/alert.service';

@Component({
  selector: 'app-register',
  templateUrl: 'register.component.html',
  styleUrls: ['register.component.scss'],
  animations: [toggleAnimation],
})
export class CoverRegisterComponent implements OnInit {
  user: UserSendCodeDTO | null = null;
  userComplete: UserDTO | null = null;
  registerForm: FormGroup;
  isModalVisible: boolean = false;
  isDarkMode: boolean = false;
  interval: any;
  spanish: boolean = true;
  store: any;
  currYear: number = new Date().getFullYear();
  currentImage: string = '';
  formGroup: FormGroup;
  departments: Array<{ name: string; cities: string[] }> = [];
  cities: string[] = [];

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    public router: Router,
    private appSetting: AppService,
    private analitycs: AnalitycsService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private alertService: AlertService,
  ) {
    this.formGroup = this.fb.group({
      vehiclePlate: [''],
      countryCode: [''],
    });
    this.initStore();
    //Reactive-Form
    this.registerForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      city: ['', Validators.required],
      typeOfId: ['', Validators.required],
      documentNumber: ['', [Validators.required, Validators.pattern(/^\d+$/)]], //only numbers
      countryCode: ['', Validators.required],
      phone: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
      vehiclePlate: ['', [Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Za-z0-9]+$')]],
      vehicleModel: ['', Validators.required],
      termsAccepted: [false, Validators.requiredTrue],
    });
  }
  async initStore() {
    this.analitycs.logEvent('init register', {
      view: 'register',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  ngOnInit() {
    this.storeData
      .select((state) => state.index.locale)
      .subscribe((locale) => {
        this.spanish = locale === 'es';

        // Actualizar la imagen según el idioma
        this.currentImage = locale === 'en' ? '../../assets/images/pit1inglish.jpg' : '../../assets/images/pit.jpg';
      });
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }

  async openModal() {
    this.analitycs.logEvent('openModal', {
      view: 'register',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    if (this.registerForm.valid) {
      this.alertService.showLoading('Enviando informacion...');
      this.user = {
        email: this.registerForm.value.email,
        phone: {
          code: this.registerForm.value.code,
          number: this.registerForm.value.phone,
        },
      };

      this.userComplete = {
        document_number: this.registerForm.value.documentNumber,
        email: this.registerForm.value.email,
        name: {
          first_name: this.registerForm.value.firstName,
          last_name: this.registerForm.value.lastName,
          full_name: `${this.registerForm.value.firstName} ${this.registerForm.value.lastName}`,
        },
        country_code: this.registerForm.value.countryCode,
        city: this.registerForm.value.city,
        password: this.registerForm.value.password,
        document_type: this.registerForm.value.typeOfId,
        phone: {
          code: this.registerForm.value.countryCode,
          number: this.registerForm.value.phone,
        },
      };
      const rsp = await this.commonService.sendSmsCode(this.user);
      console.log(rsp);
      this.alertService.close();
      this.isModalVisible = true;
    } else {
      console.error('Formulario inválido');
    }
  }
  closedModal() {
    this.analitycs.logEvent('closedModal', {
      view: 'register',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.isModalVisible = false;
  }
  networks() {
    this.analitycs.logEvent('networks', {
      view: 'register',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
  }
  GoToLogin() {
    this.analitycs.logEvent('GoToLogin', {
      view: 'register',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.router.navigate(['../login']);
  }
  forgotPassword() {
    this.analitycs.logEvent('forgotPassword', {
      view: 'register',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.router.navigate(['../forgot-password']);
  }
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
    this.formGroup.get('vehiclePlate')?.setValue(input.value, { emitEvent: false });
  }
  countries = [
    // 1. Colombia
    {
      code: '57',
      name: 'Colombia',
      departments: [
        { name: 'Antioquia', cities: ['Medellín', 'Envigado', 'Bello', 'Itagüí', 'Apartadó', 'Turbo', 'La Ceja'] },
        { name: 'Cundinamarca', cities: ['Bogotá', 'Soacha', 'Zipaquirá', 'Chía', 'Fusagasugá', 'Girardot', 'La Calera'] },
        { name: 'Valle del Cauca', cities: ['Cali', 'Buenaventura', 'Palmira', 'Tuluá', 'Jamundí', 'Buga', 'Yumbo'] },
        { name: 'Atlántico', cities: ['Barranquilla', 'Soledad', 'Malambo', 'Puerto Colombia', 'Galapa', 'Sabanalarga', 'Campo de la Cruz'] },
        { name: 'Santander', cities: ['Bucaramanga', 'Cúcuta', 'Ocaña', 'Piedecuesta', 'Barrancabermeja', 'Girón', 'Floridablanca'] },
        { name: 'Bolívar', cities: ['Cartagena', 'Turabá', 'Arjona', 'Magangué', 'Mompós', 'Santa Rosa', 'El Carmen de Bolívar'] },
        { name: 'Magdalena', cities: ['Santa Marta', 'Ciénaga', 'Fundación', 'Aracataca', 'Pivijay', 'El Banco', 'Pueblo Viejo'] },
      ],
    },
    // 2. Argentina
    {
      code: '56',
      name: 'Argentina',
      departments: [
        { name: 'Buenos Aires', cities: ['Buenos Aires', 'La Plata', 'Mar del Plata', 'Bahía Blanca', 'Tandil', 'San Nicolás', 'Pergamino'] },
        { name: 'Córdoba', cities: ['Córdoba', 'Villa María', 'Río Cuarto', 'San Francisco', 'Bell Ville', 'Alta Gracia', 'Villa Carlos Paz'] },
        { name: 'Santa Fe', cities: ['Rosario', 'Santa Fe', 'Rafaela', 'Reconquista', 'Venado Tuerto', 'Villa Gobernador Gálvez', 'Esperanza'] },
        { name: 'Mendoza', cities: ['Mendoza', 'San Rafael', 'Godoy Cruz', 'Luján de Cuyo', 'Maipú', 'General Alvear', 'Rivadavia'] },
        { name: 'Tucumán', cities: ['San Miguel de Tucumán', 'Tafí Viejo', 'Monteros', 'Lules', 'Simoca', 'Concepción', 'Aguilares'] },
        { name: 'Salta', cities: ['Salta', 'Orán', 'Metán', 'La Caldera', 'Rosario de la Frontera', 'Cachi', 'San Ramón'] },
        { name: 'Entre Ríos', cities: ['Paraná', 'Concordia', 'Gualeguaychú', 'Victoria', 'Concepción del Uruguay', 'Viale', 'Nogoyá'] },
      ],
    },
    // 3. México
    {
      code: '52',
      name: 'México',
      departments: [
        { name: 'Jalisco', cities: ['Guadalajara', 'Zapopan', 'Tlaquepaque', 'Tonalá', 'Puerto Vallarta', 'Tepatitlán', 'Ciudad Guzmán'] },
        { name: 'Nuevo León', cities: ['Monterrey', 'San Pedro', 'Guadalupe', 'Apodaca', 'Escobedo', 'San Nicolás', 'García'] },
        { name: 'Ciudad de México', cities: ['Ciudad de México', 'Iztapalapa', 'Ecatepec', 'Tlalnepantla', 'Naucalpan', 'Cuauhtémoc', 'Xochimilco'] },
        { name: 'Puebla', cities: ['Puebla', 'Tehuacán', 'Atlixco', 'San Martín Texmelucan', 'Cholula', 'Cuautlancingo', 'Zacapoaxtla'] },
        { name: 'Veracruz', cities: ['Veracruz', 'Xalapa', 'Coatzacoalcos', 'Córdoba', 'Poza Rica', 'Minatitlán', 'Orizaba'] },
        { name: 'Guanajuato', cities: ['León', 'Guanajuato', 'Irapuato', 'Celaya', 'Salamanca', 'Silao', 'San Miguel de Allende'] },
        { name: 'Baja California', cities: ['Tijuana', 'Mexicali', 'Ensenada', 'Rosarito', 'Tecate', 'San Felipe', 'San Quintín'] },
      ],
    },
    // 4. Estados Unidos
    {
      code: '1',
      name: 'Estados Unidos',
      departments: [
        { name: 'California', cities: ['Los Ángeles', 'San Francisco', 'San Diego', 'Sacramento', 'San Jose', 'Fresno', 'Oakland'] },
        { name: 'Texas', cities: ['Houston', 'Dallas', 'Austin', 'San Antonio', 'Fort Worth', 'El Paso', 'Arlington'] },
        { name: 'Florida', cities: ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Tallahassee', 'St. Petersburg', 'Hialeah'] },
        { name: 'New York', cities: ['New York', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse', 'Albany', 'Schenectady'] },
        { name: 'Illinois', cities: ['Chicago', 'Aurora', 'Rockford', 'Joliet', 'Naperville', 'Springfield', 'Peoria'] },
        { name: 'Pennsylvania', cities: ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Scranton', 'Lancaster'] },
        { name: 'Ohio', cities: ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Parma'] },
      ],
    },
    // 5. España
    {
      code: '34',
      name: 'España',
      departments: [
        { name: 'Madrid', cities: ['Madrid', 'Alcalá de Henares', 'Móstoles', 'Fuenlabrada', 'Leganés', 'Getafe', 'Alcorcón'] },
        { name: 'Cataluña', cities: ['Barcelona', 'Tarragona', 'Girona', 'Lleida', 'Sabadell', 'Terrassa', 'Badalona'] },
        { name: 'Andalucía', cities: ['Sevilla', 'Málaga', 'Córdoba', 'Granada', 'Cádiz', 'Almería', 'Huelva'] },
        { name: 'Valencia', cities: ['Valencia', 'Alicante', 'Castellón', 'Elche', 'Gandía', 'Torrent', 'Orihuela'] },
        { name: 'Galicia', cities: ['A Coruña', 'Vigo', 'Santiago de Compostela', 'Lugo', 'Ourense', 'Ferrol', 'Pontevedra'] },
        { name: 'País Vasco', cities: ['Bilbao', 'San Sebastián', 'Vitoria', 'Getxo', 'Barakaldo', 'Irun', 'Portugalete'] },
        { name: 'Castilla y León', cities: ['Valladolid', 'León', 'Burgos', 'Salamanca', 'Segovia', 'Palencia', 'Zamora'] },
      ],
    },
    // 6. Brasil
    {
      code: '55',
      name: 'Brasil',
      departments: [
        { name: 'São Paulo', cities: ['São Paulo', 'Campinas', 'Santos', 'Osasco', 'São Bernardo', 'Santo André', 'Sorocaba'] },
        { name: 'Rio de Janeiro', cities: ['Rio de Janeiro', 'Niterói', 'Duque de Caxias', 'Nova Iguaçu', 'Belford Roxo', 'São Gonçalo', 'Volta Redonda'] },
        { name: 'Minas Gerais', cities: ['Belo Horizonte', 'Uberlândia', 'Contagem', 'Juiz de Fora', 'Betim', 'Montes Claros', 'Ipatinga'] },
        { name: 'Bahia', cities: ['Salvador', 'Feira de Santana', 'Vitória da Conquista', 'Camaçari', 'Juazeiro', 'Ilhéus', 'Barreiras'] },
        { name: 'Paraná', cities: ['Curitiba', 'Londrina', 'Maringá', 'Foz do Iguaçu', 'Ponta Grossa', 'Cascavel', 'São José dos Pinhais'] },
        { name: 'Rio Grande do Sul', cities: ['Porto Alegre', 'Caxias do Sul', 'Pelotas', 'Canoas', 'Santa Maria', 'Passo Fundo', 'Novo Hamburgo'] },
        { name: 'Ceará', cities: ['Fortaleza', 'Caucaia', 'Juazeiro do Norte', 'Maracanaú', 'Sobral', 'Crato', 'Iguatu'] },
      ],
    },
    // 7. Alemania
    {
      code: '49',
      name: 'Alemania',
      departments: [
        { name: 'Bayern', cities: ['Munich', 'Nuremberg', 'Augsburg', 'Regensburg', 'Ingolstadt', 'Würzburg', 'Fürth'] },
        { name: 'Baden-Württemberg', cities: ['Stuttgart', 'Mannheim', 'Karlsruhe', 'Freiburg', 'Heidelberg', 'Ulm', 'Heilbronn'] },
        { name: 'Nordrhein-Westfalen', cities: ['Cologne', 'Düsseldorf', 'Dortmund', 'Essen', 'Duisburg', 'Bochum', 'Wuppertal'] },
        { name: 'Hessen', cities: ['Frankfurt', 'Wiesbaden', 'Kassel', 'Darmstadt', 'Offenbach', 'Hanau', 'Marburg'] },
        { name: 'Sachsen', cities: ['Leipzig', 'Dresden', 'Chemnitz', 'Zwickau', 'Plauen', 'Görlitz', 'Freiberg'] },
        { name: 'Rheinland-Pfalz', cities: ['Mainz', 'Ludwigshafen', 'Koblenz', 'Trier', 'Kaiserslautern', 'Worms', 'Speyer'] },
        { name: 'Berlin', cities: ['Berlin', 'Potsdam', 'Oranienburg', 'Bernau', 'Strausberg', 'Hennigsdorf', 'Velten'] },
      ],
    },
  ];

  onCountryChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedCode = selectElement.value;

    // Buscar país seleccionado y cargar sus departamentos
    const selectedCountry = this.countries.find((country) => country.code === selectedCode);
    this.departments = selectedCountry ? selectedCountry.departments : [];

    // Resetear valores anteriores
    this.cities = [];
    this.registerForm.get('department')?.setValue('');
    this.registerForm.get('city')?.setValue('');
  }

  onDepartmentChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedDepartment = selectElement.value;

    // Buscar departamento seleccionado y cargar sus ciudades
    const selectedDept = this.departments.find((dept) => dept.name === selectedDepartment);
    this.cities = selectedDept ? selectedDept.cities : [];

    // Resetear ciudad
    this.registerForm.get('city')?.setValue('');
  }
}
